import {Component, OnInit} from '@angular/core';
import {DebuggingService} from '../../services/debugging.service';
import {ActivatedRoute} from '@angular/router';
import {ReportService} from '../../services/report.service';
import {CurrencyService} from '../../services/currency-service';
import {DebuggingDTO} from '../../model/debuggingDTO';

@Component({
  templateUrl: './debugging.component.html',
  styleUrls: ['./debugging.component.scss']
})
export class DebuggingComponent implements OnInit {

  debugging: DebuggingDTO;

  constructor(private service: DebuggingService, private route: ActivatedRoute, private currencyService: CurrencyService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params =>
      this.service.get(params.clientId, ReportService.getReportTypeFromUrl(params.reportType), params.year)
        .subscribe(debugging => this.debugging = debugging));
  }

  euro(value) {
    return this.currencyService.symbol('EUR') + this.currencyService.format(value);
  }
}
